// import React from "react";

// const items = [
//   { name: "Jeans", pct: 70 },
//   { name: "Shirts", pct: 40 },
//   { name: "Belts", pct: 60 },
//   { name: "Caps", pct: 80 },
//   { name: "Others", pct: 20 },
// ];

// const MostSold: React.FC = () => {
//   return (
//     <div className="card p-3 most-sold-card">
//       <h6 className="mb-3">Most Sold Items</h6>
//       {items.map((it) => (
//         <div key={it.name} className="mb-3">
//           <div className="d-flex justify-content-between">
//             <small>{it.name}</small>
//             <small>{it.pct}%</small>
//           </div>
//           <div className="progress" style={{ height: 8 }}>
//             <div className="progress-bar" role="progressbar" style={{ width: `${it.pct}%` }} aria-valuenow={it.pct} aria-valuemin={0} aria-valuemax={100}></div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default MostSold;



// import React, { useMemo } from "react";
// import { IOrder } from "../utils/interface";

// interface Props {
//   orders: IOrder[];
// }

// const MostSold: React.FC<Props> = ({ orders }) => {
//   const topProducts = useMemo(() => {
//     const map: Record<string, { name: string; quantity: number }> = {};

//     orders.forEach((order) => {
//       order.orderItems.forEach((item) => {
//         if (!map[item.name]) {
//           map[item.name] = { name: item.name, quantity: 0 };
//         }
//         map[item.name].quantity += item.quantity;
//       });
//     });

//     return Object.values(map)
//       .sort((a, b) => b.quantity - a.quantity)
//       .slice(0, 5);
//   }, [orders]);

//   if (topProducts.length === 0)
//     return (
//       <div className="card p-3">
//         <h6>Most Sold Items</h6>
//         <p>No sales yet. Showing sample items.</p>
//         <ul>
//           <li>Sample Chair</li>
//           <li>Modern Sofa</li>
//           <li>Wooden Bed</li>
//           <li>Dining Table</li>
//           <li>Office Desk</li>
//         </ul>
//       </div>
//     );

//   return (
//     <div className="card p-3">
//       <h6>Most Sold Items</h6>
//       <ul className="list-group">
//         {topProducts.map((p, i) => (
//           <li key={i} className="list-group-item d-flex justify-content-between">
//             <span>{p.name}</span>
//             <span>{p.quantity}</span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default MostSold;







import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../context/globalContext";

interface IMostSoldItem {
  name: string;
  totalSold: number;
  pct: number;
}

const MostSold: React.FC = () => {
  const { orders } = useGlobalContext();
  const [items, setItems] = useState<IMostSoldItem[]>([]);

  useEffect(() => {
    if (!orders || orders.length === 0) return;

    // ✅ Filter only approved orders
    const approvedOrders = orders.filter(
      (order: any) =>
        order.orderStatus?.toLowerCase() === "approved" ||
        order.paymentStatus?.toLowerCase() === "approved"
    );

    const productSales: Record<string, number> = {};

    // ✅ Collect sold quantities per product
    approvedOrders.forEach((order: any) => {
      if (Array.isArray(order.items)) {
        order.items.forEach((item: any) => {
          const name = item.name || item.productName || "Unnamed Product";
          const quantity = Number(item.quantity) || 1;

          if (!productSales[name]) productSales[name] = 0;
          productSales[name] += quantity;
        });
      }
    });

    // ✅ Sort & compute top-selling items
    const sorted = Object.entries(productSales)
      .map(([name, totalSold]) => ({ name, totalSold }))
      .sort((a, b) => b.totalSold - a.totalSold)
      .slice(0, 8); // Top 8

    const maxSold = sorted[0]?.totalSold || 1;
    const withPct = sorted.map((p) => ({
      ...p,
      pct: Math.round((p.totalSold / maxSold) * 100),
    }));

    setItems(withPct);
  }, [orders]);

  return (
    <div className="card p-3 shadow-sm border-0 rounded-3">
      <h6 className="mb-3 fw-semibold text-dark">
        <i className="bi bi-bar-chart-fill me-2 text-primary"></i>
        Most Sold Items
      </h6>

      {items.length > 0 ? (
        items.map((it) => (
          <div key={it.name} className="mb-3">
            <div className="d-flex justify-content-between small mb-1">
              <span className="text-truncate" title={it.name}>
                {it.name}
              </span>
              <span className="fw-semibold text-dark">
                {it.totalSold} sold
              </span>
            </div>
            <div className="progress" style={{ height: 8 }}>
              <div
                className="progress-bar bg-primary"
                role="progressbar"
                style={{ width: `${it.pct}%` }}
                aria-valuenow={it.pct}
                aria-valuemin={0}
                aria-valuemax={100}
              ></div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted small mb-0">No approved orders yet.</p>
      )}
    </div>
  );
};

export default MostSold;
